import React, { FC } from 'react';
import * as S from './styles';

interface Props {
  className?: string;
  onClick: () => void;
}

const DevToolsTrigger: FC<Props> = ({ className, onClick }) => (
  <S.DevToolsButton
    onClick={onClick}
    data-testid="devToolsButton"
    title="Toggle dev tools"
    aria-label="Toggle dev tools"
    className={className}
  >
    <S.Icon name="devTools" />
  </S.DevToolsButton>
);
export default DevToolsTrigger;
